module.exports = __webpack_public_path__ + "img/logo_golang.5297af15.png";